import API from "@/config/api.js";

class DashboardService {

  getAnnualRevenueProfit() {
    return API.get(`dashboard/annual-revenue-profit`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  getRevenueTarget(year) {
    return API.get(`dashboard/revenue-target/${year}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

}

export default new DashboardService();
